import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { ReportFilterModel } from "./report-filter.model";

@Injectable()
export class ReportFilterService {
  JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

 public GetSharedVehicleGroupList(input?: DataListModel, companyHashId?: string, vehicleHashId?: string, instanceHashId?: string): Observable<IAPIResponse> {
    let getSVGUrl = WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL;
    let queryString = this.authService.HandleAPIListInput(input);

    getSVGUrl = getSVGUrl + "?" + queryString;
    if (companyHashId) {
      getSVGUrl = getSVGUrl + "&companyHashId=" + companyHashId;
    }
    if (vehicleHashId) {
      getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
    }
    if (instanceHashId) {
      getSVGUrl = getSVGUrl + "&instanceHashId=" + instanceHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSVGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/report/models/report-filter.service.ts